import React from "react";

import { Skeleton, Stack } from "@mui/material";

const DEFAULT_HEIGHT = "189px";

const SkeletonCard = () => {
  return (
    <Stack width="100%" direction="column" gap="24px">
      <Skeleton variant="rounded" width="100%" height="24px" />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
      <Skeleton variant="rounded" width="100%" height={DEFAULT_HEIGHT} />
    </Stack>
  );
};

export default SkeletonCard;
